import React from 'react';
import { Box, Dialog, IconButton, makeStyles } from '@material-ui/core';
import { XIcon } from './adsAgentIcons';
import { AD } from './adsAgentTokens';

// Port of whatsapp-console-frontend `src/pages/AdTemplates/CreativePreviewDialog.js`.
const useStyles = makeStyles((theme) => ({
  paper: {
    background: 'transparent',
    boxShadow: 'none',
    overflow: 'visible',
    margin: theme.spacing(2),
  },
  backdrop: { backgroundColor: 'rgba(0,0,0,0.82)' },
  wrap: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  close: {
    position: 'absolute',
    top: -8,
    right: -8,
    zIndex: 1,
    background: AD.surface,
    padding: 6,
    '&:hover': { background: AD.primarySoft },
  },
  image: {
    maxHeight: '88vh',
    maxWidth: '100%',
    borderRadius: AD.radiusLg,
    display: 'block',
    background: '#000',
  },
}));

const CreativePreviewDialog = (props: Props): React.ReactElement | null => {
  const { open, imageUrl, onClose } = props;
  const classes = useStyles();
  if (!imageUrl) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      classes={{ paper: classes.paper }}
      BackdropProps={{ classes: { root: classes.backdrop } }}
    >
      <Box className={classes.wrap}>
        <IconButton
          className={classes.close}
          size="small"
          onClick={onClose}
          aria-label="Close preview"
        >
          <XIcon size={20} />
        </IconButton>
        <img className={classes.image} src={imageUrl} alt="Ad creative" />
      </Box>
    </Dialog>
  );
};

interface Props {
  open: boolean;
  imageUrl: string;
  onClose: () => void;
}

export default CreativePreviewDialog;
